import { render, staticRenderFns } from "./BasicPaginator.vue?vue&type=template&id=cc026748&scoped=true&"
import script from "./BasicPaginator.vue?vue&type=script&lang=js&"
export * from "./BasicPaginator.vue?vue&type=script&lang=js&"
import style0 from "./BasicPaginator.vue?vue&type=style&index=0&id=cc026748&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc026748",
  null
  
)

export default component.exports